import { Subscription } from 'rxjs';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { ArrHlp } from 'src/lib/fliko/helpers/array.helper';
import { TimeHlp } from 'src/lib/fliko/helpers/time.helper';
import { ToString } from 'src/lib/fliko/helpers/toString.helper';
import { PersonContactData } from 'src/lib/fliko/models/person/resident.data';
import { InvitationType } from 'src/lib/fliko/models/appInvite.data';
import { RWDService } from 'src/app/view/user-context/services/rwd.service';
import { AppInviteService } from 'src/app/view/users/services/appInvite.service';
import { UsersStateService } from 'src/app/view/users/services/users.state.service';
import { AppInviteTemplate } from '../../models/appInvite.view-model';
import { DialogService } from '../../services/dialog.service';

// ! If you want to change this variable, update 'appInvite.sendTT'
export const INVITE_TIME_DIFF = TimeHlp.ms.DAY;

@Component({
  selector: 'app-details-contacts[personalData]',
  templateUrl: './details-contacts.component.html',
  styleUrls: ['./details-contacts.component.scss']
})
export class DetailsContactsComponent implements OnInit, OnDestroy {
  @Input() personalData!: PersonContactData;
  @Input() canInvite = false;
  @Input() canMessage = false;
  @Input() canAlert = false;
  @Input() canCall = false;
  @Input() callingPhone: string | null = null;
  @Output() phoneCall = new EventEmitter<string>();

  public inviteSentNumber: string = '';
  public inviteSent = false;

  private subscription$ = new Subscription();

  stringArray = ArrHlp.make;
  InvitationType = InvitationType;

  constructor(
    public rwdService: RWDService,
    private router: Router,
    private dialogService: DialogService,
    private userStateService: UsersStateService,
    private inviteService: AppInviteService
  ) {}

  ngOnInit(): void {
    if (this.personalData.id) {
      this.subscription$.add(
        this.inviteService.getUserInviteData$(this.personalData.id).subscribe((invitation) => {
          if (invitation) {
            const diffInMs = Date.now() - TimeHlp.timestamp(invitation.createDate);
            this.inviteSent = diffInMs < INVITE_TIME_DIFF;
            this.inviteSentNumber = invitation.phoneNumber;
          } else {
            this.inviteSent = false;
          }
        })
      );
    }
  }

  ngOnDestroy(): void {
    this.subscription$.unsubscribe();
  }

  public showEventLog(): void {
    this.router.navigate(['/event-log'], { queryParams: { search: ToString.fullName(this.personalData) } });
    this.dialogService.closeAllDialogs();
  }

  public showResidentHistory(): void {
    this.userStateService.showResidentHistory(this.personalData.id);
  }

  public getInvitation(phone: string): AppInviteTemplate {
    return {
      name: this.personalData.name,
      lastName: this.personalData.lastName,
      phoneNumber: phone,
      receiverId: this.personalData.id
    };
  }

  public isInvitedNumber(number: string): boolean {
    return !this.inviteSentNumber.localeCompare(number.replace(/\s/g, ''));
  }

  public sendAlert(): void {
    this.dialogService.closeAllDialogs();
    this.router.navigate(['news', 'sms', 'create'], { queryParams: { receiverId: this.personalData.id } });
  }

  public call(phone: string): void {
    if (!this.canCall || this.callingPhone) return;
    this.phoneCall.emit(phone);
  }
}
